"use client";

import React from "react";
import { Calendar, ShieldCheck } from "lucide-react";

interface LastUpdatedProps {
  date?: string;
  className?: string;
  showVerified?: boolean;
}

export function LastUpdated({
  date = "September 2026",
  className = "",
  showVerified = true,
}: LastUpdatedProps) {
  return (
    <div
      className={`inline-flex items-center gap-2 px-3 py-1 rounded-full text-xs bg-slate-100 dark:bg-slate-800/80 border border-slate-200 dark:border-slate-700/80 text-slate-600 dark:text-slate-300 ${className}`}
    >
      <div className="flex items-center gap-1.5 font-medium">
        <Calendar className="w-3.5 h-3.5 text-blue-500 dark:text-cyan-400" />
        <span>Last verified & updated: <strong className="font-semibold text-slate-800 dark:text-slate-100">{date}</strong></span>
      </div>
      {showVerified && (
        <>
          <span className="text-slate-300 dark:text-slate-600">•</span>
          <span className="flex items-center gap-1 text-[11px] text-emerald-600 dark:text-emerald-400 font-semibold">
            <ShieldCheck className="w-3 h-3" />
            Verified
          </span>
        </>
      )}
    </div>
  );
}
